import React from "react";

export const StrategyContext = React.createContext(undefined);


